import React, { useEffect, useState } from 'react';
import { Box, Button, Divider, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../hooks/useAuth';
import { makeStyles } from '@mui/styles';
import { CssTextField } from '../layout/elements';
import { NotificationManager } from 'react-notifications';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { setReqFree } from '../../services/material-services';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import PhoneForwardedIcon from '@mui/icons-material/PhoneForwarded';
import DraftsIcon from '@mui/icons-material/Drafts';
import ProgressWait from '../layout/progress';
import { useNavigate } from 'react-router-dom';

// import * as mac from './mac';
// import getMAC, { isMAC } from 'getmac'
// import getMAC from 'getmac/compiled-types';
// import { networkInterfaces } from 'os';
// const os = require('os'); 
// import {os} from 'os';
// const os = require( 'os' );


const useStyles = makeStyles( theme => ({
    header_dtl: {
        fontFamily: 'Segoe UI',
        marginRight: '10px',
        marginTop: '10px',
        color: theme.mainAccentColor
    },
    memberContainer:{
      display: 'grid',
      gridTemplateColumns: '100px auto'
    },
    image_cover:{
        height:500, 
        width:'100%', 
        paddingLeft: '-2rem',
        paddingRight: '-1rem',
    }
}));


function RequestBuy() {
    
    const { authData, authDataLang } = useAuth();
    
    const [remarks, setRemarks ] = useState('');
    const [typeJob, setTypeJob ] = useState('');
    const [loading, setLoading ] = useState(false);
    const cssClass = useStyles();
    const navigate = useNavigate();
    
    useEffect(() => {
        window.scrollTo(0, 0);
        if(!authData){
            navigate('/login')
        }
    }, [authData]);


    const handelSubmit = async e => {
        e.preventDefault();
        setLoading(true);

        const addNewMaterial = await setReqFree(authData?.token, 
                    {user: authData?.user.id, job_detail: typeJob, remarks: remarks})
        // console.log(addNewMaterial)
        if (addNewMaterial){
            NotificationManager.success('درخواست شما ثبت شد.')
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان ثبت درخواست وجود دارد')
        }
        // await uploadImageMaterial(matID, uploaddata);
        setLoading(false)
        navigate(-1)
    }

    if (loading) return <ProgressWait statusWait={true}/> 

  return (
    <React.Fragment>
    <div style={{minHeight: 1000}} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
        
        <div style={{display: 'grid', gridTemplateColumns: '1fr 10rem'}}>
            <Typography
                fontFamily='b_mitra' 
                component="div"
                variant="h2"
                >
                درخواست مشاوره رایگان
            </Typography>
        </div>        
        <hr/>
        <Box 
            sx={{
                p: 2,
                bgcolor: '#E7EBF0',
                display: 'block',
                gap: 2,
                width: '100%',
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'left',
              }}
            >
            <Paper elevation={3} sx={{
                    display: 'block',
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    textAlign: 'right',
                }} >

                <form onSubmit={handelSubmit}>
                    <div style={{textAlign: 'right', marginRight: 20}}>
                        <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                            <Grid item>
                                <AssuredWorkloadIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <CssTextField id="input-detail" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            زمینه فعالیت شغلی*
                                        </Typography>
                                    )}
                                    fullWidth
                                    variant="standard"  value={typeJob}
                                    onChange={ e => setTypeJob( e.target.value )} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end' sx={{ my: 2 }}>
                            <Grid item sx={{marginTop: '1fr', marginBottom: 'auto',}}>
                                <ArrowLeftIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10}>
                                <CssTextField id="input-remark" 
                                    label={(
                                        <Typography
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            >
                                            توضیحات ( در مورد شغل و هدف خود از ساخت سایت توضیحات مختصری ارائه نمایید )*
                                        </Typography>
                                    )}
                                    multiline
                                    fullWidth
                                    rows={4} 
                                    className={cssClass.header_dtl}
                                    variant="standard" value={remarks}
                                    onChange={ e => setRemarks( e.target.value )} />
                            </Grid>
                        </Grid>
                    </div>
                    <br />
                    <Divider />
                    <br/>
                                
                    <Button sx={{fontFamily: 'b_mitra', paddingLeft: 5, paddingRight: 5, margin: 5}} 
                        variant="contained" color="primary" type='submit'
                        disabled={!typeJob || !remarks}>
                        <Typography
                            fontFamily='b_mitra' 
                            component="div"
                            variant="h4"
                            >
                            ثبت
                        </Typography>
                    </Button>
                </form>
            </Paper>
        </Box>
    </div>
    </React.Fragment>
  );
}

export default RequestBuy;
